module.exports = __webpack_public_path__ + "media/images/web/favicon/ms-icon-70x70-e02d692618fea8a585d81daa0c1c8798.png";